<template>
  <b-container class="inner-item-epreuve">
    <b-row style="height: 100%">
      <b-col class="flyer_container" md="2" v-bind:style="{ backgroundImage: 'url(' + epreuve.url_flyer + ')' }">
      </b-col>
      <b-col md="10" class="epreuve_meta">
        <p class="epreuve-name">
          <b>{{ epreuve.nom_epreuve }} - {{ epreuve.date_epreuve }}</b>
        </p>
        <a :href="'https://sportips.fr/plateformeResultats/#/epreuve?id=' + epreuve.id">Lien résultats</a><br />
        <a :href="$store.getters.base_url + '/admin/QRCode/get.php?id=' + epreuve.id" target="_blank">Génerer un lien
          QRCode</a>
        <p>Liste des courses :</p>
        <p v-for="(course, index) in epreuve.champs_speciaux" :key="index" style="margin-bottom: 0">
          <b>{{ course.nom_course }}</b> :
          <a
            :href="'https://sportips.fr/plateformeResultats/#/epreuve?id=' + epreuve.id + '&p=' + course.nom_course">Lien</a>
        </p>

        <b-row style="margin-top: 10px">
          <b-col>
            <b-button size="sm" style="margin-bottom: 5px" v-if="epreuve.url_export"><a :href="epreuve.url_export"
                download style="color: inherit"><v-icon name="file-download" scale="1" /> GMCAP</a></b-button>
            <b-button size="sm" style="margin-bottom: 5px"><router-link target="_blank"
                :to="{ name: 'Edit', query: { id: epreuve.id } }"
                style="color: inherit">Modifier</router-link></b-button>
            <b-button size="sm" style="margin-bottom: 5px" v-if="epreuve.url_export"><router-link target="_blank" :to="{
              name: 'Update',
              query: { id: epreuve.id },
            }" style="color: inherit">Mettre à jour</router-link></b-button>

            <b-button v-if="epreuve.url_export.includes('/live/export_live')" size="sm" style="margin-bottom: 5px" @click="confirmFix(epreuve.id, epreuve.nom_epreuve)">Corriger
              erreurs</b-button>
            <b-button size="sm" style="margin-bottom: 5px"
              @click="confirmDelete(epreuve.id, epreuve.nom_epreuve)">Supprimer</b-button>
            <b-modal v-model="modalShow" hide-footer>Êtes-vous sur de vouloir supprimer cette epreuve ?<br /><br />
              <b-button class="cButton1" @click="deleteEpreuve">Supprimer cette epreuve</b-button></b-modal>

            <b-modal v-model="modalFixShow" hide-footer>En poursuivant, vous allez supprimer tous les résultats, puis
              forcer la re-synchronisation. <br />
              A n'utiliser que dans le cas ou la mise à jour ne corrige pas les problèmes. <br />
              <span style="font-size:0.8rem">Exemples: coureurs assignés à un mauvais dossard, coureur en
                trop...</span><br /><br />
              <b-button size="sm" style="margin-bottom: 5px" v-if="epreuve.url_export"><router-link  :to="{
                name: 'UpdateAndFix',
                query: { id: epreuve.id },
              }" style="color: inherit">Mettre à jour</router-link></b-button></b-modal>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <span v-if="epreuve.maj_auto" class="maj_auto maj_auto_on"><v-icon name="sync-alt" spin scale="1" /> MAJ auto</span>
    <span v-else class="maj_auto maj_auto_off"><v-icon name="times" scale="1" /> MAJ auto</span>
  </b-container>
</template>

<script>
export default {
  props: ["epreuve"],
  data() {
    return {
      modalShow: false,
      modalFixShow: false,
    };
  },
  methods: {
    formatDate(d) {
      var arr = d.split("/");
      var date;
      if (arr.length > 0) {
        arr[1] = parseInt(arr[1]) - 1;
        date = new Date(parseInt(arr[2]), arr[1], parseInt(arr[0]));
        return date;
      }
      return new Date();
    },
    confirmDelete() {
      this.modalShow = true;
    },
    confirmFix() {
      this.modalFixShow = true;
    },
    deleteEpreuve() {
      this.modalShow = false;
      this.$emit("deleteEpreuve", this.epreuve.id);
    },
    fixEpreuve() {
      this.modalFixShow = false;
      this.$emit("fixEpreuve", this.epreuve.id);
    },
  },
  created() {
    if (this.epreuve.url_flyer === "") {
      this.epreuve.url_flyer = "https://sportips.fr/plateformeResultats/uploads/noflyer.jpg";
    }
    const now = new Date();
    const date_epreuve = this.formatDate(this.epreuve.date_epreuve);
    const diffTime = Math.abs(date_epreuve - now);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    this.epreuve.maj_auto = diffDays < 8 && this.epreuve.source_export === "server";
  },
};
</script>

<style>
.maj_auto {
  position: absolute;
  top: 5px;
  right: 20px;
  padding: 5px 10px;
  color: white;
  border-radius: 8px;
  font-size: 11px;
  border: 2px solid #e2e2e2;
}

.maj_auto_on {
  background-color: rgb(1, 117, 1);
}

.maj_auto_off {
  background-color: rgb(117, 1, 1);
}

.inner-item-epreuve {
  background-color: #e2e2e2;
  border: 1px solid #d8d7d7;
  border-radius: 3px;
  overflow: hidden;
  -webkit-box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.15);
  height: 100%;
}

.inner-item-epreuve p {
  margin-bottom: 0;
}

.flyer_container {
  min-height: 100px;
  padding: 0;
  background-size: cover;
  background-position: center;
  -webkit-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.1);
}

.epreuve_meta {
  text-align: left !important;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/component/Admin/EpreuveItem.vue